/**
 * URL marker of the full-screen Map Studio workspace. Nested routes such as
 * `/map/map-studio/:map_id/ai-unit-test` belong to it as well.
 */
const MAP_STUDIO_SEGMENT = 'map/map-studio';

/**
 * True when `url` points at Map Studio. Query strings and fragments are
 * ignored so callers can pass `Router.url` as-is.
 */
export function isMapStudioUrl(url: string | null | undefined): boolean {
  if (!url) {
    return false;
  }
  const path = url.split('?')[0].split('#')[0];
  return path.includes(MAP_STUDIO_SEGMENT);
}
